import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Token resolution:
//  • If we're inside the /admin area, prefer the admin token (`zumroo_token`).
//  • Otherwise (public site / listing pages / owner portal), prefer the regular
//    user JWT (`zumroo_user_token`).
//  • Fall back to the other key if the preferred one is empty — covers cross-area
//    navigation without forcing a re-login.
const getToken = () => {
  try {
    const onAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
    const admin = localStorage.getItem("zumroo_token") || "";
    const user = localStorage.getItem("zumroo_user_token") || "";
    if (onAdmin) return admin || user;
    return user || admin;
  } catch {
    return "";
  }
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401/403 handler: clear stale token and bounce to /admin/login
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const onAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
    const onLogin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin/login");
    // Only force redirect for admin-area calls and only when we're inside /admin (not the public site)
    if ((status === 401 || status === 403) && onAdmin && !onLogin && !url.includes("/admin/login")) {
      localStorage.removeItem("zumroo_token");
      localStorage.removeItem("zumroo_admin_email");
      window.location.replace("/admin/login");
    }
    return Promise.reject(error);
  }
);

export default api;

export const isAndroid = () => /android/i.test(navigator.userAgent);
export const isMobile = () => /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  return JSON.stringify(d);
};
